import styled from 'styled-components';

import { COLORS } from 'styles/constants';

export const Container = styled.div`
  margin: 30px 0;
  width: 100%;

  background: ${COLORS.white};

  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    object-fit: cover;
    width: width 80%;
    margin: 0 50px;

    border-radius: 25px 0 0 25px;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: column;

    img {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 80%;
      height: 100%;
    }
  }

  @media only screen and (min-width: 1700px) {
    padding: 40px;

    img {
      width: 800px;
    }
  }
`;

export const AboutText = styled.div`
  padding: 35px 50px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    font-size: 30px;
    margin-bottom: 20px;
    color: ${COLORS.primary};
  }

  p {
    line-height: 25px;
    font-size: 18px;
    color: ${COLORS.darkBackground};
  }

  span {
    color: ${COLORS.primary};
    font-family: Georgia, serif;
    font-size: 1.1em;
  }

  .quotename {
    margin-top: 15px;
    text-align: right;
    color: ${COLORS.primary};
  }

  @media only screen and (max-width: 900px) {
    padding: 22px;

    h2 {
      font-size: 2.5vmax;
    }

    p {
      font-size: 1.7vmax;
      line-height: 20px;
    }
  }

  @media only screen and (min-width: 1700px) {
    p {
      line-height: 35px;
    }
  }
`;
